import React from 'react';
import { Route } from 'react-router-dom';
import { Breadcrumb } from 'react-breadcrumbs';

const RouteBreadcrumb = ({
  component: Component,
  includeSearch = false,
  render,
  ...props
}) => (
  <Route
    {...props}
    render={routeProps => (
      <Breadcrumb
        data={{
          title: props.title,
          pathname: routeProps.match.url,
          search: includeSearch ? routeProps.location.search : null
        }}
      >
        {Component ? <Component {...routeProps} /> : render(routeProps)}
      </Breadcrumb>
    )}
  />
);

export default RouteBreadcrumb;



// WEBPACK FOOTER //
// ./src/components/layout/RouteBreadcrumb.js